module.exports = __webpack_public_path__ + "static/media/right-arrow.279196e3.svg";